module.exports = __webpack_public_path__ + "img/googlemap.be7575a5.jpeg";